import styled from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  background: var(--background-overlay);
  backdrop-filter: blur(8px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  z-index: 9999;
`;

export const Inner = styled.div`
  position: absolute;
  background: var(--background-elevated);
  color: var(--text-primary);
  box-shadow: 0px 8px 32px rgba(51, 20, 0, 0.16);
  border-radius: 32px;
  max-width: 420px;
  width: calc(100% - 16px);
  bottom: 8px;
  padding: 48px 24px 24px;
  display: grid;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  @media (min-width: 1024px) {
    padding: 56px 48px 48px;
    bottom: auto;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const LiquidityThumbnailWrapper = styled.div`
  margin: 0 auto;
`;
